import React from 'react';
import { Grid } from 'semantic-ui-react';
import fields, { fieldLengths } from '@/constants/fields';
import DatasourceInputField from './DatasourceInputField';
import DatasourceUrlHostField from './DatasourceUrlHostField';

const DatasourceCompactTokenFields = ({ disabled, settings, updateSettings }) => (
  <>
    <Grid.Row>
      <DatasourceUrlHostField
        disabled={disabled}
        host={settings.host}
        saveErrors={settings.saveErrors}
        updateSettings={updateSettings}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="dataset"
        field={fields.NAME}
        onChange={(value) => updateSettings({ name: value })}
        saveErrors={settings.saveErrors}
        text={settings.name}
      />
    </Grid.Row>
    <Grid.Row>
      <DatasourceInputField
        disabled={disabled}
        entity="token"
        field={fields.PASSWORD}
        maxLength={fieldLengths.large}
        onChange={(value) => updateSettings({ password: value })}
        saveErrors={settings.saveErrors}
        text={settings.password}
        type="password"
      />
    </Grid.Row>
  </>
);

export default DatasourceCompactTokenFields;
